export default {
  access_dashboards: {},
}
